import { Spin } from "antd";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

import { useSession } from "./SessionProvider";

export function RequireSession({ children }: { children: ReactNode }) {
  const { state } = useSession();
  const location = useLocation();
  if (state.status === "loading") {
    return (
      <div className="full-page-center">
        <Spin size="large" tip="正在恢复登录状态…">
          <div style={{ width: 200, height: 80 }} />
        </Spin>
      </div>
    );
  }
  if (state.status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
